import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Process from './pages/Process';
import Contact from './pages/Contact';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Privatkunden from './pages/Privatkunden';
import SelbstCheck from './pages/SelbstCheck';
import Businesskunden from './pages/Businesskunden';
import UnternehmensCheck from './pages/UnternehmensCheck';
import TargetAudience from './pages/TargetAudience';
import Services from './pages/Services';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="ueber-mich" element={<About />} />
        <Route path="arbeitsweise" element={<Process />} />
        <Route path="fuer-wen" element={<TargetAudience />} />
        <Route path="services">
          <Route index element={<Services />} />
          <Route path="privatkunden">
            <Route index element={<Privatkunden />} />
            <Route path="selbst-check" element={<SelbstCheck />} />
          </Route>
          <Route path="businesskunden">
            <Route index element={<Businesskunden />} />
            <Route path="unternehmens-check" element={<UnternehmensCheck />} />
          </Route>
        </Route>
        <Route path="kontakt" element={<Contact />} />
        <Route path="impressum" element={<Impressum />} />
        <Route path="datenschutz" element={<Datenschutz />} />
      </Route>
    </Routes>
  );
}

export default App;